"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSubscriptionType = exports.AppSubscriptionType = void 0;
var AppSubscriptionType;
(function (AppSubscriptionType) {
    AppSubscriptionType["FREE"] = "free";
    AppSubscriptionType["PRO"] = "pro";
})(AppSubscriptionType || (exports.AppSubscriptionType = AppSubscriptionType = {}));
var UserSubscriptionType;
(function (UserSubscriptionType) {
    UserSubscriptionType["BASIC"] = "basic";
    UserSubscriptionType["PREMIUM"] = "premium";
})(UserSubscriptionType || (exports.UserSubscriptionType = UserSubscriptionType = {}));
